import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { IntakeSectionsView } from "@/components/admin/IntakeSectionsView";

export const Route = createFileRoute("/admin/intakes")({ component: Intakes });

function Intakes() {
  const [rows, setRows] = useState<any[]>([]);
  useEffect(() => {
    (async () => {
      const { data } = await supabase
        .from("intake_forms")
        .select("*")
        .order("submitted_at", { ascending: false })
        .limit(100);
      setRows(data ?? []);
    })();
  }, []);

  return (
    <div>
      <h2 className="font-display text-xl font-semibold text-foreground">Formularios de datos del pedido</h2>
      <p className="mt-1 text-sm text-muted-foreground">Cada formulario está enlazado al pedido del cliente. Para revisar el contexto completo (estado, pago, notas, timeline) abre el detalle del pedido.</p>
      <div className="mt-4 space-y-3">
        {rows.map((r) => (
          <details key={r.id} className="rounded-md border border-hairline bg-surface p-4">
            <summary className="flex cursor-pointer flex-wrap items-center justify-between gap-3 text-sm text-foreground">
              <span className="min-w-0 flex-1">{r.legal_full_name ?? "—"} · {r.email} · {new Date(r.submitted_at).toLocaleString()}</span>
              <span className="flex flex-wrap gap-2">
                <Link
                  to="/admin/formularios/$id"
                  params={{ id: r.id }}
                  onClick={(e: React.MouseEvent) => e.stopPropagation()}
                  className="rounded-md border border-hairline bg-surface-2 px-2.5 py-1 text-xs text-foreground hover:bg-surface"
                >
                  Ver formulario →
                </Link>
                <Link
                  to="/admin/pedidos/$id"
                  params={{ id: r.order_id }}
                  hash="formulario"
                  onClick={(e: React.MouseEvent) => e.stopPropagation()}
                  className="rounded-md border border-hairline bg-surface-2 px-2.5 py-1 text-xs text-foreground hover:bg-surface"
                >
                  Ver pedido →
                </Link>
              </span>
            </summary>
            <div className="mt-3">
              {r.sections ? <IntakeSectionsView sections={r.sections} /> : (
                <pre className="max-h-96 overflow-auto rounded bg-surface-2 p-3 text-xs text-muted-foreground">
                  {JSON.stringify(r.payload, null, 2)}
                </pre>
              )}
            </div>
          </details>
        ))}
        {rows.length === 0 && <div className="text-muted-foreground">Sin formularios todavía.</div>}
      </div>
    </div>
  );
}

